import isEmpty from "lodash/isEmpty"
import get from "lodash/get"
/* eslint-disable react/static-property-placement */
import { Component } from "react"
import PropTypes from "prop-types"
import { withLocalization } from "hoc-lib/localization"
import { userType } from "constants-lib/authentication"
import AlertMessage from "./components/AlertMessage"
import "./UrlStatusMessage.scss"

export const getErrorMessageType = (
  sourcePage,
  cloudCraze,
  customerSelections,
  userAccount,
  lob,
) => {
  const isExistingCustomerGroupApi =
    customerSelections.getCombinedProductUrlStatus === `fulfilled` &&
    (isEmpty(
      get(customerSelections, `combinedProductSupportData.productResults`, {}),
    ) ||
      customerSelections.combinedProductSupportData.productResults[lob])
  const isLoggedIn = userAccount.userState === userType.LOGGED_IN
  const isExistingCustomer =
    (customerSelections.getProductsUrlStatus === `fulfilled` &&
      get(customerSelections, `productSupportData.existingCustomer`) === `Y`) ||
    isExistingCustomerGroupApi
  const masStatus = isExistingCustomer
    ? get(
        customerSelections,
        `productSupportData.data.wm_metadata.mas_status`,
        ``,
      )
    : ``
  const isCustomerIneligible = get(
    customerSelections,
    `productSupportData.isIneligibleCustomer`,
    false,
  )
  const isCustomerResultFailed =
    customerSelections.getProductsUrlStatus === `fulfilled` &&
    get(customerSelections, `productSupportData.customerResultFailed`) === true
  const isOrderHistoryFailed =
    (cloudCraze?.getOrderSummaryState === `failed` &&
      get(cloudCraze, `getOrderSummaryStatusCode`, 0) >= 300) ||
    (cloudCraze?.getOrderDetailsState === `failed` &&
      get(cloudCraze, `getOrderDetailsStatusCode`, 0) >= 300)

  /*
    Service is unavailable for existing customers using the new backend group API.
  */
  const serviceUnavailable =
    (customerSelections.getProductsUrlStatus === `fulfilled` &&
      get(customerSelections, `productSupportData.serviceUnavailable`) ===
        true) ||
    isExistingCustomerGroupApi

  const isCityBiledEligible =
    get(customerSelections, `cityBilledEligibility.serviceUnavailable`) === true

  const searchFailed =
    get(customerSelections, `cityBilledEligibility.searchFailed`) === true

  const isFailedRequest = customerSelections.getProductsUrlStatus === `failed`
  const invalidAddress =
    customerSelections.getProductsUrlStatus === `fulfilled` &&
    get(customerSelections, `productSupportData.invalidAddress`) === true

  const pricingUnavailableValue =
    (customerSelections.getProductsUrlStatus === `fulfilled` &&
      get(customerSelections, `productSupportData.pricingUnavailable`) ===
        true) ||
    (get(customerSelections, `productSupportData.pricingUnavailable`) ===
      true &&
      isExistingCustomerGroupApi)
  const hasMASStatus =
    masStatus === `BNKPCYCAN` ||
    masStatus === `WRTOFFCAN` ||
    masStatus === `CUTOFFCAN` ||
    masStatus === `ACTIVE` ||
    masStatus === `CUTOFF` ||
    masStatus === `INACTVHLD`

  let messageType = ``

  /*
    Backend API says that the existing customer is ineligible.
    That could mean that an existing commercial customer is trying to buy a commercial product.

    The customer is ineligible to be redirected to CloudCraze (no URL will be passed back by API).
    Show EXISTING_ACCOUNT_USER message.
  */
  if (isExistingCustomer && isCustomerIneligible) {
    messageType = `EXISTING_ACCOUNT_USER`
  }

  if (isExistingCustomer && (hasMASStatus || masStatus === ``)) {
    /* Not sure why this is here, but Rajesh said someone asked him to put this here. */
    if (hasMASStatus) {
      messageType = `EXISTING_CUSTOMER_MESSAGE_ANONYMOUS`
    } else {
      /* masStatus must be empty at this point. */
      messageType = isLoggedIn
        ? `EXISTING_CUSTOMER_MESSAGE_LOGGED_IN`
        : `EXISTING_CUSTOMER_MESSAGE_GUEST`
    }
  }

  if (
    isCustomerResultFailed ||
    isFailedRequest ||
    searchFailed ||
    (sourcePage === `ORDER_HISTORY` && isOrderHistoryFailed)
  ) {
    messageType = `CUSTOMER_SEARCH_FAILED`
  }

  if (
    isCityBiledEligible ||
    serviceUnavailable ||
    (masStatus === `CANCELLED` && isCustomerIneligible === true)
  ) {
    messageType = `SERVICE_NOT_AVAILABLE`
  }

  if (invalidAddress) {
    messageType = `INVALID_ADDRESS`
  }

  if (pricingUnavailableValue) {
    messageType = `PRICING_UNAVAILABLE`
  }

  return messageType
}

export const strings = {
  en_CA: {
    EXISTING_CUSTOMER_MESSAGE_GUEST: `It appears that an existing account is associated with this address. Please log in to your account or contact (800) 665-1898 for more information.`,
    EXISTING_CUSTOMER_MESSAGE_LOGGED_IN: `It appears that an existing account is associated with this address. Please try with a different address or contact (800) 665-1898 for more information.`,
    EXISTING_CUSTOMER_MESSAGE_ANONYMOUS: `It appears that an existing account is associated with this address. Please contact (800) 665-1898 for more information.`,
    CUSTOMER_SEARCH_FAILED: `We are sorry, but we are not able to service you at this time. Please try again later or contact (800) 665-1898 for more information.`,
    SERVICE_NOT_AVAILABLE: `We are sorry, but we do not service your address at this time. Please contact (800) 665-1898 for more information.`,
    INVALID_ADDRESS: `We could not find this address. Please try again with a valid address.`,
    //  Change pricing unavailable message later
    PRICING_UNAVAILABLE: `There is no pricing available for this address.`,
  },
  fr_CA: {
    EXISTING_CUSTOMER_MESSAGE_GUEST: `Il semble qu'un compte existant soit associé à cette adresse. Veuillez vous connecter à votre compte ou communiquer avec le service à la clientèle au (800) 665-1898 pour de plus amples renseignements.`,
    EXISTING_CUSTOMER_MESSAGE_LOGGED_IN: `Il semble qu’un compte existant est associé à cette adresse. Merci de réessayer avec une adresse différente ou contactez le (800) 665-1898 pour de plus amples renseignements.`,
    EXISTING_CUSTOMER_MESSAGE_ANONYMOUS: `Il semble qu’un compte existant est associé à cette adresse. Veuilez composer le (800) 665-1898 pour de plus amples renseignements.`,
    CUSTOMER_SEARCH_FAILED: `Nous sommes désolés, mais nous ne sommes pas en mesure de vous servir pour le moment. Veuillez réessayer plus tard ou composez le (800) 665-1898 pour de plus amples renseignements.`,
    SERVICE_NOT_AVAILABLE: `Nous sommes désolés, mais nous ne traitons pas votre adresse pour le moment. Veuilez composer le (800) 665-1898 pour de plus amples renseignements.`,
    INVALID_ADDRESS: `Nous n’avons pas pu trouver cette adresse. Veuillez réessayer avec une adresse valide.`,
    PRICING_UNAVAILABLE: `There is no pricing available for this address.`,
  },
}

class UrlStatusMessage extends Component {
  static propTypes = {
    strings: PropTypes.object.isRequired,
    reduxState: PropTypes.object.isRequired,
    sourcePage: PropTypes.string,
  }

  static defaultProps = {
    sourcePage: ``,
  }

  getAlertMessage() {
    const { strings, reduxState, sourcePage } = this.props

    const { cloudCraze, customerSelections, userAccount } = reduxState
    const messageType = getErrorMessageType(
      sourcePage,
      cloudCraze,
      customerSelections,
      userAccount,
    )
    if (messageType !== ``) {
      return strings[messageType]
    }
    return ``
  }

  render() {
    return <AlertMessage message={this.getAlertMessage()} />
  }
}

export default withLocalization(strings)(UrlStatusMessage)
